module.exports = __webpack_public_path__ + "2ce04ce201cdc8be65b2e7ac0ab15846.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-36.png
 ** module id = 1028
 ** module chunks = 0
 **/